import { ApiQueryParams, ApiViewSet, apiList } from '@frontend/api-utils';

export enum WidgetType {
    LowStockReport = 'LowStockReport',
    StockWarningWidget = 'StockWarningWidget',
    LowStockView = 'LowStockView',
    UntrackedItens = 'UntrackedItemsWidget'
}

export interface WidgetTemplate {
    id: number;
    name: string;
    description: string;
    type: WidgetType;
    settings_params: {
        data: {
            name: string;
            type: string;
            options?: any[];
        }[];
    };
    width: number;
    height: number;
}

export enum WidgetQueryParams {
    ACCOUNT = 'account'
}

const widgetTemplateViewSet: ApiViewSet = {
    baseName: 'widget-templates'
};

export async function fetchWidgetTemplatesApi(queryParams: ApiQueryParams<WidgetQueryParams>): Promise<WidgetTemplate[]> {
    return apiList<WidgetTemplate, WidgetQueryParams>(widgetTemplateViewSet, queryParams);
}
